import { useState } from 'react';
import type { Project } from '../types/project';
import { PROJECTS_PER_PAGE } from '../constants/projectConstants';

interface UseProjectPaginationProps {
  projects: Project[];
}

interface UseProjectPaginationReturn {
  displayedProjects: Project[];
  hasMore: boolean;
  isLoading: boolean;
  loadMore: () => void;
}

export const useProjectPagination = ({ projects }: UseProjectPaginationProps): UseProjectPaginationReturn => {
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const displayedProjects = projects.slice(0, page * PROJECTS_PER_PAGE);
  const hasMore = displayedProjects.length < projects.length;

  const loadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      setPage(prev => prev + 1);
      setIsLoading(false);
    }, 500);
  };

  return {
    displayedProjects,
    hasMore,
    isLoading,
    loadMore,
  };
}; 